import { Spacer, VDBText } from "@components/atoms";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import styled from "styled-components/native";
import { VDBIcons } from "@utils/VDBIcons";
import { SpaceType } from "@components/atoms/Spacer/types";
import { GoBackProps } from "./types";
import { useTranslation } from "react-i18next";

const GoBackComponent = ({
  title,
  action,
  testID,
  dataTestId,
}: GoBackProps) => {
  const typography = useTypographyStore();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <GoBackContentView
      onPress={action}
      {...(testID && { testID, "data-testId": dataTestId })}
    >
      <VDBIcon
        name={VDBIcons.LEFT}
        variant={IconsVariant.VDBCustom}
        size={SpaceType.Big}
        color={theme["core-06"]}
      />
      <Spacer size={SpaceType.ExtraSmall} />
      <VDBText type={typography["Body-M"]} color={theme["link-static"]}>
        {title ?? t("productDetailPage.goBack.text")}
      </VDBText>
    </GoBackContentView>
  );
};

const GoBackContentView = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
`;

export default GoBackComponent;
